import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';

export default function TwoColContent({
    global,
    title,
    text,
    items
}) {
    return (
        <section className={`${styles.root} py-5`}>
            <Container>
                <header className="text-center mb-4">
                    {title}
                    {text}
                </header>
                {items && items.length > 0 && (
                    <>
                        {(items || []).map((item, index) => (
                            <Row className={`${styles.item} ${index == 0 ? "" : "flex-row-reverse"} align-items-center my-5`} key={index}>
                                <Col md={6}>
                                    <figure>
                                        <SourceFlowImage
                                            src={item?.image ? item.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                            size="1000x"
                                            alt={`${item?.id}`}
                                            className="card-img"
                                            />
                                    </figure>
                                </Col>
                                <Col md={6}>
                                    <article className={`${index == 0 ? "ps-5" : "pe-5"} my-4`}>
                                        <span dangerouslySetInnerHTML={{__html: item.text}} />
                                    </article>
                                </Col>
                            </Row>
                        ))}
                    </>
                )}
            </Container>
        </section>
    )
}